// discount-icon/index.tsx
import React from "react";
import { Flex, Popover, Typography } from "antd";
import { InfoCircleFilled } from "@ant-design/icons";
import { buildDiscountModel, formatPrice } from "@/utilities";

const { Text, Title } = Typography;

type DiscountPriceProps =
  | { item: any; align?: "start" | "end" | "center" }
  | { shipment: any; align?: "start" | "end" | "center" }
  | {
    data: any;
    kind?: "item" | "shipment";
    align?: "start" | "end" | "center";
  };

function resolveProps(p: any) {
  if ("item" in p)
    return { data: p.item, kind: "item", align: p.align ?? "end" } as const;
  if ("shipment" in p)
    return {
      data: p.shipment,
      kind: "shipment",
      align: p.align ?? "end",
    } as const;
  return { data: p.data, kind: p.kind, align: p.align ?? "end" } as const;
}

// >>> si OrderSumary necesita extraer monto/label rápido:
export function extractDescriptionDiscount(description: unknown): {
  amount: number;
  label?: string;
} {
  try {
    const parsed =
      typeof description === "string"
        ? JSON.parse(description)
        : (description as any);
    const amount = Number(parsed?.discount_amount ?? 0) || 0;
    const arr = Array.isArray(parsed?.adjustments)
      ? parsed?.adjustments
      : parsed?.adjustments
        ? [parsed.adjustments]
        : [];
    const names = arr
      .map((a: any) => String(a?.name ?? "").trim())
      .filter(Boolean);
    return { amount, label: names.length ? names.join(" + ") : undefined };
  } catch {
    return { amount: 0, label: undefined };
  }
}

export function getUnitFinalInclFromDescription(item: any): number {
  return buildDiscountModel(item, { kind: "item" }).final;
}

export const DiscountPrice: React.FC<DiscountPriceProps> = React.memo(
  (props) => {
    const { data, kind, align } = resolveProps(props);
    const model = buildDiscountModel(data, { kind }); // <<<<<< ÚNICO SOURCE OF TRUTH

    const hasDiscount = model.totalDiscount > 0;

    return (
      <Flex vertical align={align} style={{ minWidth: 120 }}>
        {hasDiscount && (
          <Popover
            content={
              <ul style={{ padding: "0 20px", margin: 0 }}>
                {model.lines.map((l, i) => (
                  <li key={i}>{l.label ? `${l.label}` : ""}</li>
                ))}
              </ul>
            }
            trigger="click"
          >
            <Text
              type="secondary"
              style={{
                fontSize: 12,
                textDecoration: "line-through",
                cursor: "pointer",
              }}
            >
              <InfoCircleFilled style={{ marginRight: 4 }} />
              {formatPrice(model.base)}
            </Text>
          </Popover>
        )}

        <Title style={{ margin: 0 }} level={5}>
          {model.final === 0 ? "FREE" : formatPrice(model.final)}
        </Title>
      </Flex>
    );
  },
);
